import React, { useState, useEffect } from 'react';
import moment from 'moment';
import Swal from 'sweetalert2';
import { Spinner } from 'react-bootstrap';
import API from '../../../../shared/AdminAxios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './ManageProductLaunch.css';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { enGB } from 'date-fns/locale';
import Pagination from 'react-js-pagination';
import PageLimitModal from '../../outstanding/PageLimitModal';
import {Button,  } from 'react-bootstrap';
import editIcon from '../../../../assets/images/edit-svgrepo-com.svg'
import deleteIcon from '../../../../assets/images/delete-btn.svg'
// Register the locale
registerLocale('en-GB', enGB);

const initialForm = { product_code: '', start_date: '', end_date: '' };

function Modal({ open, onClose, children }) {
  if (!open) return null;
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.3)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{ background: '#fff', borderRadius: 8, minWidth: 350, padding: 24, boxShadow: '0 2px 12px rgba(0,0,0,0.16)', position: 'relative' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 8, right: 12, background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#888' }} title="Close">&times;</button>
        {children}
      </div>
    </div>
  );
}



function getMinDateTime() {
  return moment().format('YYYY-MM-DDTHH:mm');
}

const PAGE_SIZE = 5;

const ManageProductLaunch = () => {
  const [products, setProducts] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
    const [pageLimitValue, setPageLimitValue] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [showPageLimit, setShowPageLimit] = useState(false);

  const handleDateChange = (date, field) => {
    if (field === 'start_date') {
      setStartDate(date);
      setForm(prev => ({
        ...prev,
        start_date: date ? moment(date).format('MM-DD-YYYY') : ''
      }));
    } else {
      setEndDate(date);
      setForm(prev => ({
        ...prev,
        end_date: date ? moment(date).format('MM-DD-YYYY') : ''
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const fetchProducts = () => {
    setLoading(true);
    API({
      method: 'GET',
      url: '/api/adm/get-launch-product',
      params: {
        page: activePage,
        limit: pageLimitValue
      }
    })
      .then((res) => {
        setProducts(res?.data?.data || []);
        setTotalCount(parseInt(res?.data?.total) || 0);
        setForm(initialForm);
      })
      .catch(() => {
        setError('Failed to fetch launch products');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchProducts();
  }, [activePage, pageLimitValue]);



  const openAddModal = () => {
    setForm(initialForm);
    setIsEditing(false);
    setEditIndex(null);
    setError('');
    setModalOpen(true);
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!form.product_code.trim() || !form.start_date || !form.end_date) {
      setError('Please fill in all fields.');
      return;
    }
    if (moment(form.start_date).isBefore(moment().startOf('day'))) {
      setError('Start date cannot be in the past.');
      return;
    }
    if (moment(form.end_date).isBefore(moment(form.start_date))) {
      setError('End date cannot be before start date.');
      return;
    }
    try {
      setLoading(true);
      await API({
        method: 'POST',
        url: '/api/adm/launch-product',
        data: form,
      });
      Swal.fire({
        title: 'Success!',
        text: 'Product launched successfully.',
        icon: 'success',
        confirmButtonText: 'OK'
      });
      setForm(initialForm);
      setStartDate(null);
      setEndDate(null);
      setModalOpen(false);
      setError('');
      fetchProducts(); // Refresh the list
    } catch (err) {
      if (err?.data?.message) {
        setError(err?.data?.message);
      } else {
        setError('Failed to launch product');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (idx) => {
    const product = products[idx];
    
    // Format dates consistently for form display
    const formatDate = (dateStr) => {
      if (!dateStr) return '';
      // Try parsing as ISO string first
      let date = moment(dateStr);
      if (!date.isValid()) {
        // If not valid, try parsing as DD-MM-YYYY
        date = moment(dateStr, 'DD-MM-YYYY', true);
      }
      return date.isValid() ? date.format('DD-MM-YYYY') : '';
    };

    setForm({
      ...product,
      start_date: formatDate(product.start_date),
      end_date: formatDate(product.end_date),
    });
    
    // Set date picker values
    const parseDateForPicker = (dateStr) => {
      if (!dateStr) return null;
      // Try parsing as ISO string first
      let date = moment(dateStr);
      if (!date.isValid()) {
        // If not valid, try parsing as DD-MM-YYYY
        date = moment(dateStr, 'DD-MM-YYYY', true);
      }
      return date.isValid() ? date.toDate() : null;
    };

    setStartDate(parseDateForPicker(product.start_date));
    setEndDate(parseDateForPicker(product.end_date));
    
    setIsEditing(true);
    setEditIndex(idx);
    setError('');
    setModalOpen(true);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!form.product_code.trim() || !form.start_date || !form.end_date) {
      setError('Please fill in all fields.');
      return;
    }
    if (moment(form.start_date).isBefore(moment().startOf('day'))) {
      setError('Start date cannot be in the past.');
      return;
    }
    if (moment(form.end_date).isBefore(moment(form.start_date))) {
      setError('End date cannot be before start date.');
      return;
    }

    try {
      setLoading(true);
      const productToUpdate = products[editIndex];
      await API({
        method: 'PUT',
        url: `/api/adm/update-launch-product/${productToUpdate.id}`,
        data: form,
      });

      setForm(initialForm);
      setIsEditing(false);
      setEditIndex(null);
      setModalOpen(false);
      setError('');
      fetchProducts(); // Refresh the list

      Swal.fire({
        title: 'Success!',
        text: 'Product updated successfully.',
        icon: 'success',
        confirmButtonText: 'OK'
      });
    } catch (err) {
      if (err?.data?.message) {
        setError(err?.data?.message);
      } else {
        setError('Failed to update product');
      }
    } finally {
      setLoading(false);
    }
  };
	const handlePageChange = (pageNumber) => {
		setActivePage(pageNumber);
	};

	const handleShowPageLimit = () => setShowPageLimit(!showPageLimit);

	const handleRadio = (event) => {
		const value = event.target.value;
		setPageLimitValue(Number(value));
		setActivePage(1);
		setShowPageLimit(false);
	};
  const handleDelete = (idx) => {
    const productToDelete = products[idx];

    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this product?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          await API({
            method: 'DELETE',
            url: `/api/adm/delete-launch-product/${productToDelete.id}`,
          });

          fetchProducts(); // Refresh the list

          Swal.fire({
            title: 'Deleted!',
            text: 'The product has been deleted successfully.',
            icon: 'success',
            confirmButtonText: 'OK'
          });
        } catch (err) {
          Swal.fire({
            title: 'Error!',
            text: 'Failed to delete the product. Please try again.',
            icon: 'error',
            confirmButtonText: 'OK'
          });
        } finally {
          setLoading(false);
        }
      }
      // If canceled, do nothing
    });
  };

  return (
    <div style={{ maxWidth: 1300, margin: '32px auto', padding: 24, background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
      <h2 style={{ textAlign: 'left', float: 'left', marginBottom: 24, fontSize: 24 }}>New Product Launch</h2>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <button
          onClick={openAddModal}
          style={{ padding: '8px 18px', background: '#1e4a8b', color: '#fff', border: 'none', borderRadius: 4, fontWeight: 600, fontSize: 16, cursor: 'pointer' }}
        >
           Add Product
        </button>
      </div>
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <h3 style={{ marginBottom: 24, textAlign: 'center' }}>{isEditing ? 'Edit Product' : 'Add Product'}</h3>
        <form onSubmit={isEditing ? handleUpdate : handleAdd} className="modal-form">
          <div className="form-group-launch">
            <label className="form-label-launch">Product Code</label>
            <input
              type="text"
              id="product-code-input"
              name="product_code"
              value={form.product_code}
              onChange={handleChange}
              placeholder="Enter product code"
              maxLength={20}
              className="form-control"
            />
          </div>

          <div className="form-group-launch">
            <label className="form-label-launch">Start Date</label>
            <DatePicker
              selected={startDate}
              onChange={(date) => handleDateChange(date, 'start_date')}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              minDate={new Date()}
              dateFormat="MM-dd-yyyy"
              placeholderText="Select start date"
              className="fixed-width-datepicker form-control"
              showYearDropdown
              scrollableYearDropdown
              yearDropdownItemNumber={15}
              locale="en-GB"
              wrapperClassName="datepicker-wrapper"
            />
          </div>

          <div className="form-group-launch">
            <label className="form-label-launch">End Date</label>
            <DatePicker
              selected={endDate}
              onChange={(date) => handleDateChange(date, 'end_date')}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate || new Date()}
              dateFormat="MM-dd-yyyy"
              placeholderText="Select end date"
              className="fixed-width-datepicker form-control"
              showYearDropdown
              scrollableYearDropdown
              yearDropdownItemNumber={15}
              locale="en-GB"
              wrapperClassName="datepicker-wrapper"
            />
          </div>

          {error && <div className="error-message">{error}</div>}
          
          <button
            type="submit"
            className="submit-button"
            style={{
              background: '#007bff',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              fontWeight: 600,
              fontSize: '16px',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1
            }}
            disabled={loading}
          >
            {loading ? <Spinner size="sm" animation="border" /> : (isEditing ? 'Update Product' : 'Add Product')}
          </button>
        </form>
      </Modal>
      <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '4px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
            <tr>
              <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: 600, backgroundColor: '#1e4a8b', color: 'white', whiteSpace: 'nowrap' }}>S. No.</th>
              <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: 600, backgroundColor: '#1e4a8b', color: 'white', minWidth: '200px' }}>Product Name</th>
              <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: 600, backgroundColor: '#1e4a8b', color: 'white', whiteSpace: 'nowrap' }}>Product Code</th>
              <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: 600, backgroundColor: '#1e4a8b', color: 'white', whiteSpace: 'nowrap' }}>Division Code</th>
              <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: 600, backgroundColor: '#1e4a8b', color: 'white', minWidth: '150px' }}>Division Name</th>
              <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: 600, backgroundColor: '#1e4a8b', color: 'white', whiteSpace: 'nowrap' }}>Start Date</th>
              <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: 600, backgroundColor: '#1e4a8b', color: 'white', whiteSpace: 'nowrap' }}>End Date</th>
              <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: 600, backgroundColor: '#1e4a8b', color: 'white', whiteSpace: 'nowrap' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {products.length === 0 ? (
              <tr>
                <td colSpan={8} style={{ textAlign: 'center', padding: '16px', color: '#888' }}>No products found.</td>
              </tr>
            ) : (
              products.map((product, idx) => (
                <tr 
                  key={idx} 
                  style={{ 
                    borderBottom: '1px solid #dee2e6',
                    backgroundColor: idx % 2 === 0 ? '#fff' : '#f8f9fa',
                    transition: 'background-color 0.2s',
                    ':hover': { backgroundColor: '#f1f3f5' }
                  }}
                >
                  <td style={{ padding: '12px 8px', textAlign: 'center', whiteSpace: 'nowrap' }}>{(activePage - 1) * pageLimitValue + idx + 1}</td>
                  <td 
                    style={{ 
                      padding: '12px 8px', 
                      textAlign: 'center',
                      cursor: 'pointer',
                      maxWidth: '200px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}
                    title={product.product_name}
                  >
                    {product.product_name}
                  </td>
                  <td style={{ padding: '12px 8px', textAlign: 'center', whiteSpace: 'nowrap' }}>{product.product_code}</td>
                  <td style={{ padding: '12px 8px', textAlign: 'center', whiteSpace: 'nowrap' }}>{product.division_code}</td>
                  <td style={{ padding: '12px 8px', textAlign: 'center', whiteSpace: 'nowrap' }}>{product.division_name}</td>
                  <td style={{ padding: '12px 8px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                    {product.start_date ? moment(product.start_date).format('DD-MM-YYYY') : ''}
                  </td>
                  <td style={{ padding: '12px 8px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                    {product.end_date ? moment(product.end_date).format('DD-MM-YYYY') : ''}
                  </td>
                  <td style={{ padding: '12px 8px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                    <div style={{ position: 'relative', display: 'inline-block', marginRight: '8px' }}>
                      <button
                        onClick={() => handleEdit(idx)}
                        style={{
                          padding: '6px',
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          transition: 'all 0.2s',
                          ':hover': {
                            opacity: 0.8,
                            transform: 'scale(1.1)'
                          }
                        }}
                        title="Edit"
                      >
                        <img src={editIcon} alt="Edit" style={{ width: '20px', height: '20px' }} />
                      </button>
                      <span style={{
                        visibility: 'hidden',
                        width: '60px',
                        backgroundColor: '#333',
                        color: '#fff',
                        textAlign: 'center',
                        borderRadius: '4px',
                        padding: '4px 8px',
                        position: 'absolute',
                        zIndex: 1,
                        bottom: '125%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        opacity: 0,
                        transition: 'opacity 0.3s',
                        fontSize: '12px',
                        whiteSpace: 'nowrap'
                      }} className="tooltip">
                        Edit
                      </span>
                    </div>
                    <div style={{ position: 'relative', display: 'inline-block' }}>
                      <button
                        onClick={() => handleDelete(idx)}
                        style={{
                          padding: '6px',
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          transition: 'all 0.2s',
                          ':hover': {
                            opacity: 0.8,
                            transform: 'scale(1.1)'
                          }
                        }}
                        title="Delete"
                      >
                        <img src={deleteIcon} alt="Delete" style={{ width: '20px', height: '20px' }} />
                      </button>
                      <span style={{
                        visibility: 'hidden',
                        width: '70px',
                        backgroundColor: '#333',
                        color: '#fff',
                        textAlign: 'center',
                        borderRadius: '4px',
                        padding: '4px 8px',
                        position: 'absolute',
                        zIndex: 1,
                        bottom: '125%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        opacity: 0,
                        transition: 'opacity 0.3s',
                        fontSize: '12px',
                        whiteSpace: 'nowrap'
                      }} className="tooltip">
                        Delete
                      </span>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {/* Pagination Controls */}
      {/* {products.length > PAGE_SIZE && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
          <button
            onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
            disabled={currentPage === 1}
            style={{ margin: '0 4px', padding: '6px 14px', borderRadius: 4, border: '1px solid #ccc', background: currentPage === 1 ? '#f0f0f0' : '#fff', cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
          >
            Previous
          </button>
          {Array.from({ length: Math.ceil(products.length / PAGE_SIZE), }, (_, i) => (
            <button
              key={i}
              onClick={() => setCurrentPage(i + 1)}
              style={{ margin: '0 2px', padding: '6px 12px', borderRadius: 4, border: '1px solid #ccc', background: currentPage === i + 1 ? '#007bff' : '#fff', color: currentPage === i + 1 ? '#fff' : '#000', cursor: 'pointer' }}
            >
              {i + 1}
            </button>
          ))}
          <button
            onClick={() => setCurrentPage((p) => Math.min(Math.ceil(products.length / PAGE_SIZE), p + 1))}
            disabled={currentPage === Math.ceil(products.length / PAGE_SIZE)}
            style={{ margin: '0 4px', padding: '6px 14px', borderRadius: 4, border: '1px solid #ccc', background: currentPage === Math.ceil(products.length / PAGE_SIZE) ? '#f0f0f0' : '#fff', cursor: currentPage === Math.ceil(products.length / PAGE_SIZE) ? 'not-allowed' : 'pointer' }}
          >
            Next
          </button>
        </div>
      )} */}
          <div className="table-footer" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="d-flex align-items-center" style={{ marginBottom: '10px' }}>
                  <span style={{ marginRight: '10px', fontWeight: 500 }}>Page Limit:</span>
                  <Button
                    variant="outline-primary"
                    onClick={handleShowPageLimit}
                    style={{
                      border: '1px solid black',
                      color: 'black',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      padding: '5px 12px'
                    }}
                  >
                    {pageLimitValue}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="16"
                      fill="currentColor"
                      className="bi bi-caret-down-fill"
                      viewBox="0 0 8 18"
                    >
                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                  </svg>
                </Button>
              </div>
              <div style={{ marginLeft: 'auto' }}>
                {Number(totalCount) > Number(pageLimitValue) && (
                  <Pagination
                    activePage={activePage}
                    itemsCountPerPage={pageLimitValue}
                    totalItemsCount={totalCount}
                    itemClass="page-item"
                    linkClass="page-link"
                    activeClass="active"
                    prevPageText="Prev"
                    nextPageText="Next"
                    onChange={handlePageChange}
                  />
                )}
              </div>
            </div>
      
    
          <PageLimitModal
            showPageLimit={showPageLimit}
            handleShowPageLimit={handleShowPageLimit}
            handleRadio={handleRadio}
            pageLimitValue={pageLimitValue}
          />
    </div>
    
    
  );
};

export default ManageProductLaunch;
